/**
 * Conduct rules shown before a candidate's first interview for a role.
 *
 * Kept short on purpose: a long list gets accepted without being read, which
 * defeats the point of asking. Six lines maximum per device.
 */

export interface InterviewRule {
  icon: string;
  text: string;
}

const SHARED: InterviewRule[] = [
  { icon: "🔇", text: "Sit somewhere quiet and be alone for the whole interview." },
  { icon: "🗣️", text: "Speak clearly and loud enough for AIRA to capture you, and let it finish the question first." },
  { icon: "📄", text: "Answer in your own words — do not read from notes, another screen, or anyone else's help." },
];

const PHONE: InterviewRule[] = [
  { icon: "📱", text: "Rest the phone on a stable surface, roughly an arm's length away." },
  { icon: "🔕", text: "Turn on Do Not Disturb — a call will interrupt your interview." },
  { icon: "🔋", text: "Stay on this tab until you finish, and keep your battery above 20% or plug in." },
];

const DESKTOP: InterviewRule[] = [
  { icon: "🎧", text: "Use headphones for clearer sound — it also stops AIRA's voice being recorded as your answer." },
  { icon: "🪟", text: "Close other tabs and apps, and stay in full-screen — leaving repeatedly ends the interview." },
  { icon: "🎙️", text: "Check the correct microphone is selected before you start." },
];

/** Ordered rules for the device the candidate is actually using. */
export function interviewRulesFor(isPhone: boolean): InterviewRule[] {
  return [...SHARED, ...(isPhone ? PHONE : DESKTOP)];
}

/** Stored against the acknowledgement so HR can see which rule set was shown. */
export function interviewRulesDevice(isPhone: boolean): "phone" | "desktop" {
  return isPhone ? "phone" : "desktop";
}
